import { useState } from "react";
import ModalVideo from "react-modal-video";
import "react-modal-video/css/modal-video.css";
import AOS from "aos";
import "aos/dist/aos.css";

import video from "../../assets/images/video.jpg";
import getIcon from "../../helper/getIcon";

const VideoOne = () => {
  const [isOpen, setIsOpen] = useState(false);

  // ✅ Your actual S3 file link
  const s3VideoUrl =
    "https://nps-kudlu.s3.ap-south-1.amazonaws.com/nps-school-video.mp4";

  return (
    <section className="video pt-50 pb-40 bg-main-25">
      <div className="container">
        <div className="section-heading text-center">
          <div className="flex-align d-inline-flex gap-8 mb-16">
            <h5 className="text-main-600 mb-0">Philosophy</h5>
          </div>

          <h2 className="mb-24" data-aos="fade-up" data-aos-duration="800">
            Our Philosophy
          </h2>

          <p data-aos="fade-up" data-aos-delay="120" data-aos-duration="900">
            At NPS, we believe in fostering a love for learning by nurturing the
            intellectual, emotional, social, physical, and creative potentials
            of our students. Through innovative teaching methodologies and a
            comprehensive curriculum, we strive to inspire curiosity, critical
            thinking, and a sense of responsibility in each learner.
          </p>
        </div>
      </div>

      <div className="video-img position-relative half-bg">
        <div className="container">
          <img
            src={video}
            alt="Campus video cover"
            className="rounded-12 cover-img"
            loading="lazy"
            data-aos="zoom-in"
            data-aos-duration="900"
          />
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            className="play-button position-absolute start-50 top-50 translate-middle z-1 w-72 h-72 flex-center bg-main-two-600 text-white rounded-circle text-2xl"
            aria-label="Play video"
          >
            {getIcon("fa-play")}
          </button>
        </div>
      </div>

      {/* ✅ Use the `custom` channel instead of YouTube */}
      {isOpen && (
        <ModalVideo
          channel="custom"
          isOpen={isOpen}
          url={s3VideoUrl} // ← direct S3 link here
          autoplay
          allowFullScreen
          onClose={() => setIsOpen(false)}
        />
      )}
    </section>
  );
};

export default VideoOne;
